import React from 'react';
import { useParams } from 'react-router-dom';

export default function PostView() {
  const { id } = useParams();

  return (
    <div style={{ padding: '1rem' }}>
      <h2>Post</h2>
      <p>This is a placeholder for post id: <strong>{id}</strong></p>
      <p>When you add a backend (Laravel), this page will fetch the full post.</p>
    </div>
  );
}
